import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import { io } from 'socket.io-client';

Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV !== 'production',
  connection: io(process.env.VUE_APP_BACKEND_URL, { path: '/api/socket-io' }),
}));
